var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "wrapper", on: { click: _vm.onClose } }, [
    _c("div", { class: { wrapper_body: true, open: _vm.modalData.open } }, [
      _c(
        "div",
        { staticClass: "row", attrs: { id: "sideBarModalComponent" } },
        [
          _c(
            "button",
            {
              staticClass: "btn btn-default closeBtn",
              on: { click: () => _vm.onClose(null, true) },
            },
            [_c("i", { staticClass: "icon-fa icon-fa-remove" })]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-3 hide_modal" }, [
            _vm.extraInfo
              ? _c("div", { staticClass: "extra_info card" }, [
                  _c("div", { staticClass: "card-header" }, [
                    _c("h6", [_vm._v(_vm._s(_vm.extraInfo.title))]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "card-body order_notification_block" },
                    [
                      _c("div", {
                        domProps: { innerHTML: _vm._s(_vm.extraInfo.body) },
                      }),
                    ]
                  ),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-9 m-0 p-0" }, [
            _c(
              "div",
              { staticClass: "editBlock p-2" },
              [
                _vm.loading
                  ? _c(
                      "div",
                      { staticClass: "loading_div" },
                      [
                        _c("pulse-loader", {
                          staticClass: "text-center",
                          attrs: { loading: _vm.loading, color: _vm.color },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("edit", {
                  attrs: {
                    orderId: _vm.modalData.orderId,
                    disableLoading: _vm.disableLoading,
                    closeOrder: _vm.onClose,
                    isModal: true,
                    fetchOrders: _vm.fetchOrders,
                  },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }